'use client';
import {InfoWindow} from '@react-google-maps/api';
import {useFontFamilyName} from '../store/fontFamilyNameStore';

type Props = {
  isVisible?: boolean;
  position: google.maps.LatLngLiteral;
  markerSize?: number;
  Content: JSX.Element;
  onCloseClick: () => void;
};

export const MapInfoWindow = (props: Props) => {
  const {isVisible, position, markerSize = 32, Content, onCloseClick} = props;

  const {fontFamilyName, setFontFamilyName} = useFontFamilyName();
  if (!fontFamilyName) {
    const font = getFontFamilyName();
    font && setFontFamilyName(font);
  }

  const infoWindowOptions: google.maps.InfoWindowOptions = {
    pixelOffset: new google.maps.Size(0, -markerSize),
  };

  if (!isVisible) return null;

  return (
    <InfoWindow position={position} options={infoWindowOptions} onCloseClick={onCloseClick}>
      <div style={{...(fontFamilyName && {fontFamily: fontFamilyName})}}>{Content}</div>
    </InfoWindow>
  );
};

function getFontFamilyName(): string | null {
  if (!document) {
    return null;
  }
  const firstH1 = document.querySelector('body h1');
  if (firstH1) {
    const computedStyle = window.getComputedStyle(firstH1);
    const fontFamily = computedStyle.fontFamily;
    const trimmedFontFamily = fontFamily.trim().replace(/['"]/g, '');
    return trimmedFontFamily;
  } else {
    return null;
  }
}
